import { ReactNode } from 'react';

import {
  PlacementWithLogical,
  Tooltip as ChakraTooltip,
} from '@chakra-ui/react';

import { WithChildren } from '~/shared/types/WithChildren';

interface ITooltipProps {
  label: ReactNode;
  placement?: PlacementWithLogical;
  isDisabled?: boolean;
  marginLeft?: number;
}

export const Tooltip: WithChildren<ITooltipProps> = ({
  label,
  placement = 'bottom',
  children,
  isDisabled = false,
  marginLeft,
}) => {
  return (
    // @ts-ignore
    <ChakraTooltip
      label={label}
      hasArrow
      closeOnClick={false}
      placement={placement}
      isDisabled={isDisabled}
      marginLeft={marginLeft}
    >
      {children}
    </ChakraTooltip>
  );
};
